import { IconButton, Modal } from '@wyz/ui';
import { PdfViewer } from '~/common/components';
import { Trans } from '~/common/context';
/* eslint-disable-next-line @wyz/module/no-relative-import */
import { PdfViewerProps } from './pdf-viewer';

type Props = {
  onClose: () => void;
} & PdfViewerProps;

function PdfModal({ onClose, ...pdfViewerProps }: Props) {
  return (
    <Modal.Container onClose={onClose} open={true} size='lg'>
      {/* `ms-auto` because Modal.Header lays its children out with
          justify-content-between: a lone child would otherwise sit on the left. */}
      <Modal.Header variant='white' closeButton={false}>
        <IconButton
          id='close-pdf-modal'
          className='ms-auto'
          variant='tertiary-grey'
          icon='close'
          iconSize='xs'
          onClick={onClose}
        >
          <Trans i18nKey='app.common.button.close' />
        </IconButton>
      </Modal.Header>
      <Modal.Body>
        <PdfViewer {...pdfViewerProps} />
      </Modal.Body>
    </Modal.Container>
  );
}

export default PdfModal;
